import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from '@/app/providers';
import { AppRoutes } from '@/app/router';
import { ErrorBoundary, RootErrorFallback } from '@/app/error-boundary';

/**
 * Root component.
 *
 * The router sits *above* the providers on purpose: the session, the guards and
 * several providers navigate, so they all need router context.
 */
export default function App(): JSX.Element {
  return (
    <ErrorBoundary fallback={(error, reset) => <RootErrorFallback error={error} reset={reset} />}>
      <BrowserRouter>
        <AppProviders>
          <AppRoutes />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
